import { request, orgBase } from '@/api/http'
import type { RiskGraph, SankeyData } from '@/api/types'

export const graphApi = {
  graph(orgId: string): Promise<RiskGraph> {
    return request(`${orgBase(orgId)}/graph`)
  },
  sankey(orgId: string): Promise<SankeyData> {
    return request(`${orgBase(orgId)}/graph/sankey`)
  },
  recordTransition(orgId: string, body: { asset_id: string; state: unknown }): Promise<unknown> {
    return request(`${orgBase(orgId)}/transition/status`, {
      method: 'POST',
      body: JSON.stringify(body),
    })
  },
}
